import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-automation',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './automation.html',
  styleUrl: './automation.css'
})
export class AutomationComponent {
  features = [
    {
      icon: 'hub',
      title: 'HubSpot Integration',
      description: 'Seamlessly integrate and optimize your HubSpot workflows for maximum marketing efficiency and lead generation.'
    },
    {
      icon: 'analytics',
      title: 'Marketo Expertise',
      description: 'Leverage advanced Marketo capabilities to create sophisticated nurture campaigns and automated marketing programs.'
    },
    {
      icon: 'mail',
      title: 'Email Automation',
      description: 'Design and deploy intelligent email campaigns that engage prospects at the right time with personalized content.'
    },
    {
      icon: 'account_tree',
      title: 'Workflow Design',
      description: 'Build complex multi-channel workflows that guide leads through their journey from awareness to conversion.'
    },
    {
      icon: 'score',
      title: 'Lead Scoring',
      description: 'Implement predictive lead scoring models that identify high-value prospects and prioritize sales efforts.'
    },
    {
      icon: 'sync',
      title: 'CRM Integration',
      description: 'Connect your marketing automation platform with CRM systems for seamless data flow and unified customer views.'
    }
  ];

  process = [
    {
      step: '01',
      title: 'Platform Assessment',
      description: 'We evaluate your current marketing technology stack, identify gaps, and recommend the optimal automation platform based on your business needs and goals.'
    },
    {
      step: '02',
      title: 'Workflow Design',
      description: 'Our team maps out customer journeys and designs automated workflows that nurture leads, score engagement, and trigger timely actions across all touchpoints.'
    },
    {
      step: '03',
      title: 'Implementation & Integration',
      description: 'We configure your automation platform, integrate with existing systems, migrate data, and set up tracking to ensure everything works seamlessly.'
    },
    {
      step: '04',
      title: 'Optimization & Training',
      description: 'After launch, we continuously optimize campaigns based on performance data and train your team to maximize the value of your automation investment.'
    }
  ];

  caseStudy = {
    client: 'TechVentures Inc.',
    industry: 'B2B SaaS',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop',
    challenge: 'TechVentures struggled with manual lead nurturing processes that resulted in a 15% conversion rate and overwhelmed sales teams with unqualified leads. Their email campaigns had low engagement and lacked personalization.',
    solution: 'We implemented a comprehensive HubSpot automation strategy including lead scoring, dynamic email nurturing based on behavior, automated lead qualification workflows, and seamless CRM integration. We designed 12 automated workflows covering different buyer personas and journey stages.',
    results: [
      { metric: '186%', label: 'Increase in qualified leads' },
      { metric: '42%', label: 'Higher email engagement rate' },
      { metric: '3.2x', label: 'Improvement in conversion rate' },
      { metric: '60%', label: 'Reduction in sales follow-up time' }
    ]
  };

  testimonial = {
    quote: 'HoneyKode transformed our marketing operations from manual chaos to automated precision. The workflows they designed not only saved our team countless hours but also dramatically improved lead quality. Our sales team now focuses on closing deals instead of chasing cold leads.',
    author: 'Jennifer Martinez',
    role: 'VP of Marketing',
    company: 'TechVentures Inc.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop'
  };
}
